module.exports = __webpack_public_path__ + "static/media/icon photo.fa53254a.png";